import { render } from "./GoodbyPatientScreen.vue?vue&type=template&id=338e5ff9&scoped=true"
import script from "./GoodbyPatientScreen.vue?vue&type=script&lang=js"
export * from "./GoodbyPatientScreen.vue?vue&type=script&lang=js"

import "./GoodbyPatientScreen.vue?vue&type=style&index=0&id=338e5ff9&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338e5ff9"]])

export default __exports__